/**
 * @generated SignedSource<<660f40e885285f6ee706e21b355855e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SourceTableDataRow_source$data = {
  readonly id: string;
  readonly name: string;
  readonly description: string;
  readonly tag: string;
  readonly slug: string;
  readonly associatedAbtestGroupMessages: ReadonlyArray<string>;
  readonly associatedPopupGroupMessages: ReadonlyArray<string>;
  readonly associatedChatbotGroupMessages: ReadonlyArray<string>;
  readonly " $fragmentType": "SourceTableDataRow_source";
};
export type SourceTableDataRow_source = SourceTableDataRow_source$data;
export type SourceTableDataRow_source$key = {
  readonly " $data"?: SourceTableDataRow_source$data;
  readonly " $fragmentSpreads": FragmentRefs<"SourceTableDataRow_source">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SourceTableDataRow_source",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associatedAbtestGroupMessages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associatedPopupGroupMessages",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associatedChatbotGroupMessages",
      "storageKey": null
    }
  ],
  "type": "Source",
  "abstractKey": null
};

(node as any).hash = "1f8077812a63bd27b873bebd24a31127";

export default node;
